import { memo } from 'react'

import { ButtonWithIcon } from 'common-components'
import RemoveIcon from 'assets/svgr-icons/Remove.svg'

import * as Styled from './styled'
import * as ParentStyled from '../../styled'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import { projectDataThunks } from 'store/features/projectData/thunks'
import { dispatch } from 'store'
import Icon from 'common-components/Icon'

const RemoveAudioSection: React.FC = () => {
  return (
    <Styled.RemoveAudioSectionWrapper>
      <ParentStyled.DivideLine />

      <ButtonWithIcon
        icon={<Icon icon={<RemoveIcon />} size="small" color="secondaryDark" />}
        onClick={() => {
          dispatch(projectDataThunks.removeSelectedAudio())
        }}
        label={translate(T.REMOVE)}
      />
    </Styled.RemoveAudioSectionWrapper>
  )
}

export default memo(RemoveAudioSection)
